import { BaseService } from './common/baseService';
import { supabase } from "@/integrations/supabase/client";
import type { Supplier } from './common/types';

export interface CreateSupplierData extends Record<string, unknown> {
  name: string;
  email?: string;
  phone?: string;
  address?: string;
  tax_number?: string;
  notes?: string;
  contact_name?: string;
  contact_email?: string;
  business_registration_number?: string;
  billing_address?: string;
  bank_account_number?: string;
  bank_account_name?: string;
  bank_account_details?: string;
  unit_tracking?: string;
}

export interface UpdateSupplierData extends Partial<CreateSupplierData> {
  id: string;
}

class SuppliersService extends BaseService {
  constructor() {
    super('suppliers');
  }

  async getSuppliers(): Promise<Supplier[]> {
    return this.getAll<Supplier>({
      orderBy: { column: 'name', ascending: true }
    });
  }

  async getSupplierById(id: string): Promise<Supplier | null> {
    return this.getById<Supplier>(id);
  }

  async createSupplier(supplierData: CreateSupplierData): Promise<Supplier> {
    return this.create<Supplier>(supplierData);
  }

  async updateSupplier({ id, ...updateData }: UpdateSupplierData): Promise<Supplier> {
    return this.update<Supplier>(id, updateData);
  }

  async deleteSupplier(id: string): Promise<void> {
    return this.delete(id);
  }

  async searchSuppliers(searchTerm: string): Promise<Supplier[]> {
    return this.executeQuery(async () => {
      return await (supabase as any)
        .from(this.tableName)
        .select('*')
        .or(`name.ilike.%${searchTerm}%,email.ilike.%${searchTerm}%,tax_number.ilike.%${searchTerm}%`)
        .order('name', { ascending: true });
    });
  }

  async getSupplierStats() {
    return this.executeQuery(async () => {
      return await supabase
        .from('suppliers')
        .select(`
          *,
          bills:bills(count)
        `);
    });
  }
}

export const suppliersService = new SuppliersService();